module.exports = __webpack_public_path__ + "img/razorpay.02944abe.png";